<div class="feature">
  <h5 class="font-16 fw-normal text-center text-uppercase mb-5">{{ 'feature.title' | translate }}</h5>
  <div class="marquee">
    <div class="track">
      <div class="content">
        <svg-icon src="{{ item.img }}" *ngFor="let item of items"></svg-icon>
      </div>
    </div>
  </div>
</div>